import { useLocation } from "react-router-dom";
import "./PageTransition.css";

/**
 * A brief, fast crossfade between pages — not a slide or anything
 * elaborate, matching a B2B trust-building site rather than a
 * consumer/entertainment one. Keying on pathname forces React to
 * remount the route's content on every navigation, which is what
 * retriggers the CSS animation below each time (a route change is not
 * a real page load, so nothing would replay the animation otherwise).
 */
export default function PageTransition({ children }) {
  const location = useLocation();
  return (
    <div key={location.pathname} className="page-transition">
      {children}
    </div>
  );
}